import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const RequiredIfValidator = (otherControlName: string): ValidatorFn => {
  let thisControl: AbstractControl;
  let otherControl: AbstractControl;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!control.parent) {
      return null;
    }

    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as AbstractControl;
      if (!otherControl) {
        throw new Error('requiredIfValidate(): other control is not found in parent group');
      }
      otherControl.valueChanges.subscribe(() => thisControl.updateValueAndValidity());
    }

    if (!otherControl) {
      return null;
    }

    if (otherControl.value && !value) {
      return {
        requiredIf: { condition: otherControl.value },
      };
    }
    return null;
  };
};
